// extracted by mini-css-extract-plugin
export var desktop = "responsive-module--desktop--3007e";
export var smartphone = "responsive-module--smartphone--3b160";